/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teal_Gold_Lynx_PokeInputs */

const en_teal_gold_lynx_poke = /** @type {(inputs: Teal_Gold_Lynx_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import successfully created`)
};

const de_teal_gold_lynx_poke = /** @type {(inputs: Teal_Gold_Lynx_PokeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import erfolgreich erstellt`)
};

/**
* | output |
* | --- |
* | "Import successfully created" |
*
* @param {Teal_Gold_Lynx_PokeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teal_gold_lynx_poke = /** @type {((inputs?: Teal_Gold_Lynx_PokeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teal_Gold_Lynx_PokeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_teal_gold_lynx_poke(inputs)
	return de_teal_gold_lynx_poke(inputs)
});